@if (spec) {
    <div class="field">
        <label soho-label for="lm-builder-display-search">{{'DisplaySearch' | translate}}</label>
        <select
            soho-dropdown
            soho-trackdirty
            id="lm-builder-display-search"
            name="lm-builder-display-search"
            data-automation-id="lm-builder-display-search-dropdown"
            [attributes]="displaySearchIDSAttributes"
            [(ngModel)]="spec.displaySearch">
            <option [value]="'default'">{{'DisplaySearchDefaultLabel' | translate}}</option>
            <option [value]="'initial'">{{'InitiallyDisplaySearchLabel' | translate}}</option>
            <option [value]="'always'">{{'AlwaysDisplaySearchLabel' | translate}}</option>
        </select>
    </div>
    @if (spec.metaDataOptions.charts.length > 0) {
        <div class="field">
            <label soho-label for="lm-builder-default-view">{{'CreateReportDefViewLabel' | translate}}</label>
            <select
                soho-dropdown
                soho-trackdirty
                id="lm-builder-default-view"
                name="lm-builder-default-view"
                data-automation-id="lm-builder-default-view-dropdown"
                [attributes]="defaultViewIDSAttributes"
                [(ngModel)]="spec.defaultView">
                <option [value]="">{{ 'list' | translate }}</option>
                @for (chart of spec.metaDataOptions.charts; track chart.value) {
                    <option [value]="chart.value">{{chart.label}}</option>
                }
            </select>
        </div>
    }
    @if (allowShowLines) {
        <div class="field">
            <label soho-label for="lm-builder-show-lines">{{ 'PageSize' | translate }}</label>
            <select
                soho-dropdown
                soho-trackdirty
                id="lm-builder-show-lines"
                name="lm-builder-show-lines"
                data-automation-id="lm-builder-show-lines-dropdown"
                [attributes]="displaySearchIDSAttributes"
                [(ngModel)]="spec.showLines">
                @for (pageSize of pageSizes; track pageSize.value) {
                    <option [value]="pageSize.value">{{pageSize.label}}</option>
                }
            </select>
        </div>
    }
    <div class="field lm-no-label">
        <input
                id="lm-builder-display-negatives-in-parens"
                name="lm-builder-display-negatives-in-parens"
                data-automation-id="lm-builder-display-negatives-in-parens-input"
                soho-checkbox
                type="checkbox"
                soho-trackdirty
                [(ngModel)]="spec.displayNegativeParens">
        <label [forCheckBox]="true" soho-label for="lm-builder-display-negatives-in-parens">{{ 'NegativeValuesInParens' | translate }}</label>
    </div>
        <div class="field lm-no-label">
            <input
                id="lm-builder-horizontal-scrolling"
                name="lm-builder-horizontal-scrolling"
                data-automation-id="lm-builder-horizontal-scrolling-input"
                soho-checkbox
                type="checkbox"
                soho-trackdirty
                [(ngModel)]="implementsHorizontalScrolling"
                (ngModelChange)="updateHorizontalScrolling()">
            <label [forCheckBox]="true" soho-label for="lm-builder-horizontal-scrolling">{{ 'HorizontalScrolling' | translate }}</label>
        </div>
    @if (implementsHorizontalScrolling) {
        <div class="field lm-no-label">
            <input
                soho-spinbox
                id="lm-builder-frozen-column"
                data-automation-id="lm-builder-frozen-column"
                class="input-xs"
                attr.data-options="{{frozenColumnIDSAttributes}}"
                [min]="1"
                [max]="spec.displayFields ? spec.displayFields.length : 1"
                [(ngModel)]="spec.frozenColumn"/>
        </div>
    }
}
